import React from "react";
// import Navigation from "../../components/Navigation";
import Footer from "../../components/Footer";
import './style.css';

const Terms = () => {
  return (
    <div className="terms-page">
      {/* <Navigation /> */}

      {/* Hero Section */}
      <section className="terms-hero">
        <div className="terms-hero-container">
          <h1>Our Terms of Service</h1>
          <p>Terms of Service (ToS) are a legal agreement between you and your users, outlining the rules and guidelines for using your website.</p>
        </div>
      </section>

      {/* About Content */}
      <section className="privacy-content">
        <div className="privacy-container">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using our website, you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree to these terms, please do not use our website.
          </p>

          <h2>2. Changes to Terms</h2>
          <p>
            We may update these Terms of Service from time to time. We will notify you of any changes by posting the new Terms of Service on this page. You are advised to review these Terms of Service periodically for any changes.
            <ul>
              <li>We reserve the right to modify the ToS</li>
              <li>Visitors will be notified of changes</li>
              {/* <li>Cookies and Tracking Technologies: To enhance your experience on our site.</li> */}
              <li>We used a 3rd party service for our analytics **insert name of service**, for more information, please visit their website and check their privacy policy.</li>
            </ul>
          </p>

          <h2>3. User Conduct</h2>
          <p>
            Acceptable Use: What users can and cannot do on the site:
            <ul>
              <li>We do not condone any harassment, hate speech, discrimination</li>
              <li>We do not allow users to post any content that is illegal, offensive, or violates the rights of others</li>
              <li>We do not allow users to engage in any activity that could harm our website or its users</li>
              <li>We do not allow users to collect personal information from others without their consent</li>
              <li>We do not allow users to use our website for any unauthorized commercial purposes</li>
            </ul>
          </p>

          <h2>4. Intellectual Property Rights</h2>
          <p>
            We own all rights, title, and interest in and to our website and its content, including all intellectual property rights. You may not use, reproduce, distribute, or create derivative works from our website or its content without our express written permission.
          </p>

          <h2>5. Disclaimers (Warranties)</h2>
          <p>
            <ul>
              <li>No warranties regarding accuracy, reliability, or uninterrupted availability of our service.</li>
              <li>No warranty that the service will meet your requirements</li>
            </ul>
          </p>

          <h2>6. Indemnification</h2>
          <p>
            You agree to indemnify, defend, and hold harmless Big Cat Graphics and its affiliates, licensors, and service providers from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys' fees) arising out of or relating to your violation of these Terms of Service or your use of our website, including, but not limited to, your User Contributions, any use of the website's content, services, and products other than as expressly authorized in these Terms of Service, or your use of any information obtained from the website.
          </p>

          <h2>7. Governing Law & Jurisdiction</h2>
          <p>
            These Terms of Service shall be governed by and construed in accordance with the laws of the Republic of South Africa, without regard to its conflict of law principles. Any legal action or proceeding arising out of or relating to these Terms of Service shall be brought exclusively in the courts located within that jurisdiction.
          </p>

          {/* <h2>8. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.
          </p>

          <h2>9. Children's Privacy</h2>
          <p>
            <ul>
              <li>
                Our website is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected personal information from a child under 13, we will take steps to delete such information as soon as possible.
              </li>
              <li>
                If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us. If we become aware that we have collected personal information from a child under 13 without verification of parental consent, we will take steps to delete that information as soon as possible.
              </li>
              <li>
                Our content is not directed to children under 13, and we do not knowingly collect personal information from children under 13.
              </li>
            </ul>
          </p>

          <h2>10. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at **insert contact email**.
          </p> */}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Terms;
